export function getZipCodeRegEx(country: CountryType) {
  if (country === 'DE') {
    return /^[0-9]{5}$/
  }
  if (country === 'HU') {
    return /^[0-9]{4}$/
  }
  if (country === 'TR') {
    return /^[0-9]{5}$/
  }
  if (country === 'UA') {
    return /^[0-9]{5}$/
  }
}
